import React from 'react';

import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import Swal from 'sweetalert2';

interface QuotaBadgeProps {
  quota: number | string | undefined;
}

function formatQuota(quota: number | string | undefined): { display: string; full: string; hasTooltip: boolean } {
  if (!quota) return { display: 'N/A', full: 'N/A', hasTooltip: false };
  const quotaStr = String(quota);
  // Check if quota contains a space as a separator
  if (quotaStr.includes(' ')) {
    // Find the position of the opening bracket
    const bracketIndex = quotaStr.indexOf(' ') !== -1 ? quotaStr.indexOf(' ') : Infinity
    
    // Truncate at bracket and add ellipsis for display
    const display = quotaStr.substring(0, bracketIndex).trim() + '...';
    const full = quotaStr.substring(bracketIndex).trim();
    
    // Return the full quota string for tooltip
    return { display, full, hasTooltip: true };
  }
  
  return { display: quotaStr, full: quotaStr, hasTooltip: false };
}

export const QuotaBadge: React.FC<QuotaBadgeProps> = ({ quota }) => {
  const quotaInfo = formatQuota(quota);

  const badgeContent = (
    <Badge variant="teal">
      <span 
        className={`whitespace-wrap ${quotaInfo.hasTooltip ? 'cursor-help' : ''}`}
        onClick={(e) => {
          if (quotaInfo.hasTooltip && window.innerWidth < 1024) {
            e.stopPropagation();
            Swal.fire({
              title: 'Quota',
              text: quotaInfo.full,
              icon: 'info',
              confirmButtonText: 'OK'
            });
          }
        }}
      >
        Quota: {quotaInfo.display}
      </span>
    </Badge>
  );

  if (!quotaInfo.hasTooltip) {
    return badgeContent;
  }

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        {badgeContent}
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p className="text-sm">{quotaInfo.full}</p>
      </TooltipContent>
    </Tooltip>
  );
};
